// RESERVATION STATUS
export const SHOW_RESERVATION_STATUS = "SHOW_RESERVATION_STATUS";
export const HIDE_RESERVATION_STATUS = "HIDE_RESERVATION_STATUS";

// CART ITEM
export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const REMOVE_CART_ITEM_ORDER_TYPE = "REMOVE_CART_ITEM_ORDER_TYPE";
export const START_EMPTY_CART = "START_EMPTY_CART";

export const SET_GUEST_MOBILE_VERIFIED = "SET_GUEST_MOBILE_VERIFIED";

export const MODIFY_CART_ITEM = "MODIFY_CART_ITEM";

// Update ItemOptions
export const INCREMENT_CART_ITEM = "INCREMENT_CART_ITEM";
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const DECREMENT_CART_ITEM = "DECREMENT_CART_ITEM";

export const SAVE_ITEM_COMMENTS = "SAVE_ITEM_COMMENTS";

export const START_CUSTOMISE_ITEM = "START_CUSTOMISE_ITEM";
export const CLEAR_CUSTOMISE_ITEM = "CLEAR_CUSTOMISE_ITEM";
export const UPDATE_ITEM_CUSTOMISATION = "UPDATE_ITEM_CUSTOMISATION";
export const SAVE_ITEM_CUSTOMISATION = "SAVE_ITEM_CUSTOMISATION";
export const FINISH_ITEM_CUSTOMISATION = "FINISH_ITEM_CUSTOMISATION";

// Customisation
export const ADD_CUSTOMISE_INDIVIDUALLY = "ADD_CUSTOMISE_INDIVIDUALLY";
export const REMOVE_CUSTOMISE_INDIVIDUALLY = "REMOVE_CUSTOMISE_INDIVIDUALLY";
export const LOAD_SAVED_INDIVIDUAL_CUSTOMISATION =
  "LOAD_SAVED_INDIVIDUAL_CUSTOMISATION";
export const REMOVE_LAST_ITEM_INSTANCE = "REMOVE_LAST_ITEM_INSTANCE";

// PLACE ORDER
export const SAVE_ORDER_DETAILS = "SAVE_ORDER_DETAILS";
export const REMOVE_CART_TIP = "REMOVE_CART_TIP";
export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const IS_SCHEDULER_ORDER_PLACE_ORDER = "IS_SCHEDULER_ORDER_PLACE_ORDER"
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAILURE = "PLACE_ORDER_FAILURE";
export const CLEAR_PLACE_ORDER = "CLEAR_PLACE_ORDER";
export const CLEAR_PLACE_ORDER_STATUS = "CLEAR_PLACE_ORDER_STATUS"
export const CLEAR_PLACE_ORDER_SUCCESS = "CLEAR_PLACE_ORDER_SUCCESS";
export const ADD_DELIVERY_ADDRESS = "ADD_DELIVERY_ADDRESS";

// Floating Cart
export const SHOW_FLOATING_CART = "SHOW_FLOATING_CART";
export const HIDE_FLOATING_CART = "HIDE_FLOATING_CART";

// Max Count Prompt
export const SHOW_ITEM_MAX_COUNT_PROMPT = "SHOW_ITEM_MAX_COUNT_PROMPT";
export const HIDE_ITEM_MAX_COUNT_PROMPT = "HIDE_ITEM_MAX_COUNT_PROMPT";

export const SET_PICKUP_TIME = "SET_PICKUP_TIME";

export const STORE_CART_RESTAURANT_DETAILS = "STORE_CART_RESTAURANT_DETAILS";

// Cart Auth
export const SET_CART_AUTH_PENDING = "SET_CART_AUTH_PENDING";

//Delivery Distance
export const SET_DELIVERY_ORDER_DISTANCE = "SET_DELIVERY_ORDER_DISTANCE";
export const CLEAR_DELIVERY_ORDER_DISTANCE = "CLEAR_DELIVERY_ORDER_DISTANCE";

// Running Cart
export const SET_RUNNING_CART = "SET_RUNNING_CART";
export const CLEAR_RUNNING_CART = "CLEAR_RUNNING_CART";

//update event order
export const UPDATE_EVENT_ORDER = "UPDATE_EVENT_ORDER";
export const UPDATE_EVENT_ORDER_SLOT = "UPDATE_EVENT_ORDER_SLOT";

export const TOTALS = "TOTALS";
export const SET_ORDER_TYPE = "SET_ORDER_TYPE";

export const SPECIAL_NOTES = "SPECIAL_NOTES"
export const REMOVE_NOTES = "REMOVE_NOTES"

export const CART_ITEM_REQUEST = "CART_ITEM_REQUEST"
export const CART_ITEM_SUCCESS = "CART_ITEM_SUCCESS"
export const CART_ITEM_FAILURE = "CART_ITEM_FAILURE"
export const REPLACE_CART_ITEMS = 'REPLACE_CART_ITEMS'

export const TOGGLE_CART_VIEW = "TOGGLE_CART_VIEW"
export const SET_SELECTED_DATE = "SET_SELECTED_DATE"
export const SET_SELECTED_TIME_SLOT = "SET_SELECTED_TIME_SLOT"
export const SET_ORDER_INSTRUCTIONS = "SET_ORDER_INSTRUCTIONS"
export const SET_DELIVERY_INSTRUCTIONS = "SET_DELIVERY_INSTRUCTIONS"
export const CLEAR_DELIVERY_INSTRUCTIONS = "CLEAR_DELIVERY_INSTRUCTIONS"

export const SET_IS_TIP_ADDEDD = "SET_IS_TIP_ADDEDD"
export const RESET_CART="RESET_CART"
export const RESERVATION_MENU_API_CALL="RESERVATION_MENU_API_CALL"
export const RESET_RESERVATION_MENU_API_CALL="RESET_RESERVATION_MENU_API_CALL";


export const NO_TIP="NOTIP";
export const CUSTOME_TIP="CUSTOME_TIP";
export const CUSTOME_TIP_VALUE="CUSTOME_TIP_VALUE";

export const CLEAR_NO_TIP="CLEAR_NOTIP";
export const CLEAR_CUSTOME_TIP="CLEAR_CUSTOME_TIP";
export const CLEAR_CUSTOME_TIP_VALUE="CLEAR_CUSTOME_TIP_VALUE";

export const CUSTOMIZATION_POPUP = 'CUSTOMIZATION_POPUP'

export const CHANGE_CALL_WAITER="CHANGE_CALL_WAITER"
export const COUPON_CLICKED = "COUPON_CLICKED"
export const CLEAR_TOTALS = "CLEAR_TOTALS"
export const ROUTE_TO_LOGIN = "ROUTE_TO_LOGIN"
export const ASK_TO_LOGIN = "ASK_TO_LOGIN"

export const CLEAR_PLACE_ORDER_LOADING="CLEAR_PLACE_ORDER_LOADING"
